<template>
  <div>
    <v-simple-table class="ma-4 produtos-table">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left" style="min-width: 400px">Produto</th>
          <th class="text-left" style="min-width: 30px">Quantidade</th>
          <th style="min-width: 60px">Unidade de medida</th>
          <th style="min-width: 200px">Especificação</th>
          <th style="min-width: 138px"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(produto, index) in requisicao.produtos"
            :key="produto.$$id"
            style="height: 60px">
          <px-cadastro-requisicao-produtos-table-item ref="produtos"
                                                      :produto="produto"
                                                      :is-rascunho="isRascunho"
                                                      :erp-campos-integracao="erpCamposIntegracao"
                                                      :campos-obrigatorios="camposObrigatorios"
                                                      :campos-hidden="camposHidden"
                                                      @remove-produto="removeProduto(index)"
                                                      @duplicar-produto="duplicar"
                                                      @replicar-campo="onReplicarCampo"/>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row dense>
      <v-col cols="12" class="text-right">
        <v-btn small color="primary" class="rounded-tag-small normal-btn-text elevation-0"
               @click="adicionarProduto">
          <v-icon small>mdi-plus</v-icon>
          Produto
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             @click="next">
        Continuar
      </v-btn>
      <v-btn text @click="previous" class="normal-btn-text">Voltar</v-btn>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash';
import validationMixin from '@/mixins/validation-mixin';
import CadastroRequisicaoProdutosTableItem
  from '@/modules/requisicao/cadastro/CadastroRequisicaoProdutosTableItem.vue';
import { isSameDate } from '@/utils/date-utils';
import { replicarCampoProdutos } from '@/utils/cadastros-adicionais-utils';
import { copyProduto, initialStateProduto } from './utils/requisicao-utils';

export default {
  mixins: [validationMixin],
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
    isEdicao: Boolean,
    camposObrigatorios: Object,
    erpCamposIntegracao: String,
    camposHidden: Object,
  },
  data() {
    return {
      isCopy: this.$route.params.isCopy,
      isRascunho: this.$route.params.isRascunho,
    };
  },
  methods: {
    onReplicarCampo(campo) {
      this.requisicao.produtos = replicarCampoProdutos(this.requisicao.produtos, campo);
    },
    isFormValid() {
      return this.$refs.produtos
        .map(produto => produto.validate())
        .every(validation => validation);
    },
    next() {
      if (!this.isFormValid()) {
        return;
      }
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    },
    duplicar(item) {
      const newProduto = {
        ...copyProduto(item, this.erpCamposIntegracao, this.requisicao),
        id: undefined,
      };
      this.requisicao.produtos.push(cloneDeep(newProduto));
    },
    adicionarProduto() {
      this.requisicao.produtos.push({
        ...initialStateProduto(this.erpCamposIntegracao, this.requisicao),
      });
    },
    removeProduto(index) {
      if (this.requisicao.produtos.length <= 1) {
        return;
      }
      this.requisicao.produtos.splice(index, 1);
      this.$emit('reset-fornecedor');
    },
    clearProjetoProdutos(oldProjeto) {
      this.requisicao.produtos = this.requisicao.produtos.map((produto) => {
        const produtoProjetoId = produto.projeto ? produto.projeto.id : null;
        const isSame = oldProjeto.id === produtoProjetoId;

        return {
          ...produto,
          projeto: isSame ? null : produto.projeto,
        };
      });
    },
    setProjetoProdutos(oldProjeto, newProjeto) {
      this.requisicao.produtos = this.requisicao.produtos.map(produto => ({
        ...produto,
        projeto: this.getProjeto(produto, oldProjeto, newProjeto),
      }));
    },
    getProjeto(produto, oldProjeto, newProjeto) {
      const oldProjetoId = oldProjeto ? oldProjeto.id : null;
      if (!produto.projeto || produto.projeto.id === oldProjetoId) {
        return newProjeto;
      }
      return produto.projeto;
    },
    clearCentroCustoProdutos(oldCentroCusto) {
      this.requisicao.produtos = this.requisicao.produtos.map((produto) => {
        const produtoCentroCustoId = produto.centroCusto ? produto.centroCusto.id : null;
        const isSame = oldCentroCusto.id === produtoCentroCustoId;

        return {
          ...produto,
          centroCusto: isSame ? null : produto.centroCusto,
        };
      });
    },
    setCentroCustoProdutos(oldCentroCusto, newCentroCusto) {
      this.requisicao.produtos = this.requisicao.produtos.map(produto => ({
        ...produto,
        centroCusto: this.getCentroCusto(produto, oldCentroCusto, newCentroCusto),
      }));
    },
    getCentroCusto(produto, oldCentroCusto, newCentroCusto) {
      const oldCentroCustoId = oldCentroCusto ? oldCentroCusto.id : null;
      if (!produto.centroCusto || produto.centroCusto.id === oldCentroCustoId) {
        return newCentroCusto;
      }
      return produto.centroCusto;
    },
    getFinalidadeCompra(produto, oldFinalidade, newFinalidade) {
      if (!produto.finalidadeCompra) {
        const finalidadeCompra = produto.produto ? produto.produto.finalidadeCompra : null;
        return finalidadeCompra ?? newFinalidade;
      }
      if (isEqual(produto.finalidadeCompra, oldFinalidade)) {
        return newFinalidade;
      }
      return produto.finalidadeCompra;
    },
    setFinalidadeCompraProdutos(oldFinalidade, newFinalidade) {
      this.requisicao.produtos = this.requisicao.produtos.map(produto => ({
        ...produto,
        finalidadeCompra: this.getFinalidadeCompra(produto, oldFinalidade, newFinalidade),
      }));
    },
    getDataEntregaProduto(produto, oldData, newData) {
      if (!produto.dataPrevisaoEntrega || isSameDate(produto.dataPrevisaoEntrega, oldData)) {
        return newData;
      }
      return produto.dataPrevisaoEntrega;
    },
    setDataEntregaProdutos(oldData, newData) {
      this.requisicao.produtos = this.requisicao.produtos.map(produto => ({
        ...produto,
        dataPrevisaoEntrega: this.getDataEntregaProduto(produto, oldData, newData),
      }));
    },
  },
  watch: {
    'requisicao.projeto': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue === undefined && oldValue) {
        this.clearProjetoProdutos(oldValue);
        return;
      }
      this.setProjetoProdutos(oldValue, newValue);
    },
    'requisicao.centroCusto': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue === undefined && oldValue) {
        this.clearCentroCustoProdutos(oldValue);
        return;
      }
      this.setCentroCustoProdutos(oldValue, newValue);
    },
    'requisicao.finalidadeCompra': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.setFinalidadeCompraProdutos(oldValue, newValue);
    },
    'requisicao.dataEntrega': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.setDataEntregaProdutos(oldValue, newValue);
    },
  },
  components: {
    pxCadastroRequisicaoProdutosTableItem: CadastroRequisicaoProdutosTableItem,
  },
};
</script>

<style scoped>
.produtos-table tr:hover:not(.v-table__expanded__content) {
  background: white !important;
}

</style>
